
import React from "react";
import PageHeader from "../../components/PageHeader";
import NewsCategoryUpdateComponent from "../../components/NewsCategory/NewsCategoryUpdate";

class NewsCategoryUpdate extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="NewsCategory Update"
                            Breadcrumb={[
                                { name: "Categories", navigate: "/categories" },
                                { name: "NewsCategory Update", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <NewsCategoryUpdateComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NewsCategoryUpdate;
